<template>
  <li v-if="!childrenLinks && isHeader" :class="['headerLink', className]">
    <router-link :to="link" class="sidebar-link">
      <span class="icon">
        <inline-svg v-if="iconImg" :src="require('@/assets/' + iconImg + '')" fill="currentColor"></inline-svg>
        <i v-else :class="fullIconName"></i>
      </span>

      <span class="link-title">{{ header }}</span>
      <sup v-if="label" :class="'text-' + labelColor" class="headerLabel">{{ label }}</sup>
      <span v-if="badge" class="badge rounded-pill bg-danger">{{ badge }}</span>
    </router-link>
  </li>

  <li v-else-if="childrenLinks" :class="['headerLink', { open: isParentActive }, className]">
    <div>
      <button type="button" class="sidebar-link" :class="{ 'parent-active': isParentActive }" @click="toggleCollapse">
        <span class="icon">
          <inline-svg v-if="iconImg" :src="require('@/assets/' + iconImg + '')" fill="currentColor"></inline-svg>
          <i v-else :class="fullIconName"></i>
        </span>

        <span class="link-title">{{ header }}</span>
        <sup v-if="label" :class="'text-' + labelColor" class="ms-1 headerLabel">{{ label }}</sup>
        <span :class="{ caretWrapper: true, carretActive: isOpen }">
          <i class="fa fa-angle-right" />
        </span>
      </button>
    </div>

    <b-collapse :id="'collapse' + index" :visible="isOpen">
      <ul class="sub-menu">
        <NavLink
          v-for="childrenLink in childrenLinks"
          :activeItem="activeItem"
          :header="childrenLink.header"
          :index="childrenLink.index"
          :link="childrenLink.link"
          :childrenLinks="childrenLink.childrenLinks"
          :key="childrenLink.link"
        />
      </ul>
    </b-collapse>
  </li>

  <li v-else class="sub-item">
    <router-link :to="index !== 'menu' && link" class="sub-link">
      <span class="link-title">{{ header }}</span>
      <sup v-if="label" :class="'text-' + labelColor" class="headerLabel">{{ label }}</sup>
    </router-link>
  </li>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'NavLink',
  props: {
    badge: { type: String, default: '' },
    header: { type: String, default: '' },
    iconName: { type: String, default: '' },
    iconImg: { type: String, default: '' },
    headerLink: { type: String, default: '' },
    link: { type: String, default: '' },
    childrenLinks: { type: Array, default: null },
    className: { type: String, default: '' },
    isHeader: { type: Boolean, default: false },
    deep: { type: Number, default: 0 },
    activeItem: { type: String, default: '' },
    label: { type: String },
    labelColor: { type: String, default: 'warning' },
    index: { type: String },
  },
  data() {
    return {
      isCollapsedByUser: false,
    }
  },
  watch: {
    $route() {
      this.isCollapsedByUser = false
    },
  },
  methods: {
    ...mapActions('layout', ['changeSidebarActive']),
    toggleCollapse() {
      if (this.isParentActive) {
        this.isCollapsedByUser = !this.isCollapsedByUser
      } else {
        this.changeSidebarActive(this.index)
        this.isCollapsedByUser = false
      }
    },
  },
  computed: {
    fullIconName() {
      return `fi ${this.iconName}`
    },
    isChildRouteActive() {
      if (!this.childrenLinks) return false

      return this.childrenLinks.some((child) => {
        if (!child.link) return false
        return this.$route.path === child.link || this.$route.path.startsWith(`${child.link}/`)
      })
    },
    isParentActive() {
      return this.isChildRouteActive
        || Boolean(this.index && this.activeItem && this.activeItem.includes(this.index))
    },
    isOpen() {
      return this.isParentActive && !this.isCollapsedByUser
    },
  },
}
</script>

<style src="./NavLink.scss" lang="scss" scoped />
